import React from "react";
import {IconXMark, IconUserGroup} from "@unibuddy/icons";
import styled from "styled-components";
import {Box, Button, View} from "@unibuddy/patron";
import {useAssistantConversationContext} from "../../providers/AssistantConversationProvider";
import {useMobileMenu} from "../../../../providers/MobileMenuProvider";
import {ChatHeaderContentProps} from "./ChatHeaderContent";

const LeftAlignedButton = styled(Button)`
    justify-content: flex-start;
`;

type MobileMenuProps = ChatHeaderContentProps & {
    isConnectButtonDisabled: boolean;
};

export function MobileMenu({handleCloseClicked, isConnectButtonDisabled}: MobileMenuProps) {
    const {onSendMessage} = useAssistantConversationContext();
    const {setIsMobileMenuOpen} = useMobileMenu();

    async function handleConnect() {
        try {
            await onSendMessage("Connect me to the right person");
        } catch (e) {
            console.error("Could not send connect me message");
        }
    }

    return (
        <Box display="flex" gap="small">
            <View padding="small" gap="small" alignItems="flex-start" width="100%" flexGrow={1}>
                <LeftAlignedButton
                    clear
                    block
                    onClick={() => {
                        setIsMobileMenuOpen(false);
                        handleConnect();
                    }}
                    disabled={isConnectButtonDisabled}
                >
                    <IconUserGroup />
                    Connect me
                </LeftAlignedButton>
                <LeftAlignedButton
                    clear
                    block
                    onClick={() => {
                        setIsMobileMenuOpen(false);
                        handleCloseClicked();
                    }}
                >
                    <IconXMark />
                    Close chat window
                </LeftAlignedButton>
            </View>
        </Box>
    );
}
